export default {
    menu : {
      home:"首页"
    },
    content:{
      main:"这里是内容"
    },
    tableIndex:{
        "EmployeeID": "员工工号",
      "Name": "姓名",
      "DeliveryLocation": "投递点",
      "XiamenHQ": "厦门总部",
      "JinjiangHQ": "晋江总部",
      "ShanghaiHQ": "上海总部",
      "HongKongHQ": "香港总部",
      "OtherRegions": "外区投单",
      "Singapore": "新加坡",
      "Malaysia": "马来西亚",
      "Thailand": "泰国",
      "Indonesia": "印度尼西亚",
      "Philippines": "菲律宾",
      "Vietnam": "越南",
      "DocumentNumber": "工单号",
      "AddDocumentNumber": "添加工单号",
      "PagesOfSupportingDocuments": "纸质张数",
      "Page": "张",
      "PleaseScanTheQRCodeOrEnterTheDocumentNumber": "请扫码或输入工单号",
      "Submit": "提交",
      "CurrentLocation": "当前位置",
      "PleaseNoteToAvoidScanningErrorsPleaseEnsureThatTheCameraIsClearWhenScanningTheDocuments": "请知悉：单据扫码需保持摄像头清晰，以免造成扫描错误！！！",
      "DocumentNumber1": "单据编号",
      "City": "城市",
      "CreationTime": "创建时间",
      "Scanned": "已扫描",
      "Delivered": "已投递",
      "NotMailed": "未邮寄",
      "VerificationException": "核对异常",
      "DocumentRemarks": "单据备注",
      "Search": "搜索",
      "PleaseEnterDocumentNumberToSearch": "请输入单据编号检索",
      "SurveySystem": "问卷调查系统",
      "FinanceScanning": "财务扫描",
      "FinancialDocument": "财务单据",
      "SurveyManagement": "问卷管理",
      "ActivityManagement": "活动管理",
      "DocumentDate": "单据时间",
      "AffiliatedBrand": "所属体系",
      "LocationName": "地点",
      "CourierTrackingNumber": "快递单号",
      "CenterName": "中心",
      "CourierServiceAvailable": "有无快递",
      "Submitter": "投单人",
      "ContactNumber": "联系电话",
      "Operator": "操作人员",
      "DeliveryReceived": "有无收递",
      "Receiver": "签收人员",
      "DocumentStatus": "纸单状态",
      "ReceivingTime": "签收时间",
      "ScanningTime": "扫描时间",
      "Reset": "重置",
      "CloseAdvancedSearch": "关闭高级搜索",
      "Close": "关闭",
      "AdvancedSearch": "高级搜索",
      "Export": "导出",
      "ImportModifiedData": "导入修改数据",
      "ImportNewData": "导入新增数据",
      "No": "序号",
      "Dispatcher": "投递人",
      "SubmissionTime": "投单时间",
      "WhetherThereIsACourierTrackingNumber": "是否有快递单号",
      "PagesOfSupportingDocuments1": "纸质张数",
      "Remarks": "备注信息",
      "ContactPersonForOtherRegions": "外区对接人",
      "TrackingNumber": "快递单号",
      "OperationTime": "操作时间",
      "CourierReceived": "是否收到快递",
      "ScanningPerson": "扫描岗",
      "TimeOfUploadVerification": "核对上传时间",
      "StatusOfPaperDocumentFlow": "纸质单据流转状态",
      "SubmissionToMailingTimeliness": "投单-邮寄时效",
      "MailingToScanningTimeliness": "邮寄-扫描时效",
      "startDate": "开始日期",
      "endDate": "结束日期",
      "have": "有",
      "nohave": "无",
      "importTitle": "导入单据数据",
      "importcontent1":"将文件拖到此处，或",
      "importcontent2":"点击上传",
      "importcontent3":"覆盖已经存在的用户数据",
      "importTips":"提示：仅允许导入“xls”或“xlsx”格式文件",
      "confirmBtn":"确 定",
      "cancelBtn":"取 消",
      "downloadExcel":"下载Excel模版"
    }
   }